import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";
import { Collapse } from "reactstrap";
import { withTranslation } from 'react-i18next';

import "./home.css";

//import SubmitModal from "./submit-modal";
import ShowValue from "../../components/ShowValue";
import ApiAssets from "../../utils/api.assets";
import ApiCompany from "../../utils/api.company";

import Carousel from "./carousel";
import TermsConditions from "./TermsConditions";
import HowToBuy from "./HowToBuy";

declare var location;
declare var FB;

class HomePage extends Component {
  constructor(props) {
    super(props);

    //localStorage.clear(); // Tentativa de entrar
    let data = localStorage.getItem("userData");
    //let name;

    if (data) {
      //let user = JSON.parse(data);
      //name = user.name.split("");
    }

    this.assetSale = { current: undefined, padding: 0 };
    this.state = {

      st_company_info: {},

      assets: [],
      classets: [],

      word: "",
      cursor: "",

      modal: false,
      modalClassets: false,
      valueSearch: "",
      key: "",
      collapseGroup: {},
      loading: false,
      loading_tables: false,
      orderByPrice: "0",
      orderByName: "0"
    };

    let company_code = '2';
    localStorage.setItem("company_code", company_code);

    ApiCompany.getCompanyInfo(company_code).then(response => {

      let company_info;

      if (response.data) {

        company_info = response.data;

        if (company_info) {
          //console.log(company_info);
          this.setState({ st_company_info: company_info })
        }
      }
    });

    ApiAssets.getOnSale(company_code).then(response => {
      let assets;

      if (response.data) {
        assets = response.data;
        
        //console.log('getOnSale');
        //console.log(assets);

          //* assets = this.searchTree(assets, ""); */}
          //* assets = assets.sort((a, b) => a.order_planets < b.order_planets ? -1 : a.order_planets > b.order_planets ? 1 : 0); */}

        if (assets) {
          this.setState({ loading: true, assets: assets });
        }
      }
    });

    this.handleScrollToElement = this.handleScrollToElement.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.collapseToggle = this.collapseToggle.bind(this);
    this.renderLine = this.renderLine.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.handleSelectOrderByPrice = this.handleSelectOrderByPrice.bind(this);
    this.handleSelectOrderByName = this.handleSelectOrderByName.bind(this);

  }

  shareFB(name, assetline) {
    FB.ui(
      {
        method: "share",
        display: "popup",
        quote: `Hey facebook friends, I've just bought a Winvite at Winvitn.io! Check this out. The asset name is ${name}!`,
        href: "https://winvite.io/assets/?assetline=" + assetline
      },
      function (response) { }
    );
  }

  handleSelectOrderByName(event) {
    const target = event.target,
      value = target.value;

    this.setState({ orderByName: value });

    let list = [];

    this.state.classets.forEach(classet => {
      list.push(classet);
    });

    switch (value) {
      case "0":
        /*list = list;*/
        break;
      case "1":
        list = list.sort((a, b) => a.current_lander < b.current_lander ? -1 : a.current_lander > b.current_lander ? 1 : 0);
        break;
      case "2":
        list = list.sort((a, b) => a.current_lander > b.current_lander ? -1 : a.current_lander < b.current_lander ? 1 : 0);
        break;
      default:
        break;
    }
  }

  handleSelectOrderByPrice(event) {
    const target = event.target,
      value = target.value;

    this.setState({ orderByPrice: value });

    let list = [];

    this.state.classets.forEach(classet => { list.push(classet); });

    switch (value) {
      case "0":
        /*list = list;*/
        break;
      case "1":
        list = list.sort((a, b) => a.price > b.price ? -1 : a.price < b.price ? 1 : 0);
        break;
      case "2":
        list = list.sort((a, b) => a.price < b.price ? -1 : a.price > b.price ? 1 : 0);
        break;
      default:
        break;
    }
  }

  searchTree(array, value) {
    array = array.filter(item => {
      if (item.child) {
        item.child.sort((a, b) => a.price < b.price ? -1 : a.price > b.price ? 1 : 0);
        item.child = this.searchTree(item.child, value);
      }

      return (item.current_lander.includes(value) || item.name.includes(value) || item.child.length > 0);
    });

    return array;
  }

  handleInput(event) {
    const target = event.target, value = target.value;
    if (value !== "") {
      const assets = this.state.copyAssets;
      let resultFilter = this.searchTree(assets, value);
      this.setState({ assets: resultFilter });
    } else {
      this.setState({
        assets: this.state.reservdAssets,
        copyAssets: this.state.reservdAssets,
        reservdAssets: JSON.parse(JSON.stringify(this.state.reservdAssets))
      });
    }
  }

  handleChange(event) {
    this.setState(...this.state, { valueSearch: event.target.value });
  }

  handleScrollToElement(event, ref) {
    const mainNode = ReactDOM.findDOMNode(this.refs[ref]);
    window.scrollTo(0, mainNode.offsetTop);
  }

  collapseToggle(id) {
    this.setState(...this.state, {
      collapseGroup: {
        ...this.state.collapseGroup,
        [id]: !this.state.collapseGroup[id]
      }
    });
  }

  toggleModalClassets = key => {
    this.setState(...this.state, {
      key: key,
      modalClassets: !this.state.modalClassets
    });
  };

  toggleModal() {
    this.setState(...this.state, { modal: !this.state.modal });
  }

  renderLine(asset) {
    if (asset.asset_line.includes(this.assetSale.current) && window.innerWidth > 768) {
      this.assetSale.padding = 45;
    } else if (asset.asset_line.includes(this.assetSale.current)) {
      this.assetSale.padding = 20;
    } else {
      this.assetSale.current = asset.asset_line;
    }

    return (
      <section className="mt-1" key={asset.asset_line}>
        <div className="row asset-row">
          <div className="col-2">
            <button hidden={!asset.child} className="btn btn-secondary mt-2" onClick={() => this.collapseToggle(asset.asset_line)}>
              <span hidden={this.state.collapseGroup[asset.asset_line]}>
                <i className="fas fa-plus" />
              </span>
              <span hidden={!this.state.collapseGroup[asset.asset_line]}>
                <i className="fas fa-minus" />
              </span>
            </button>
          </div>
          <div className="col-3">

            <Link to={"/assets/?assetline=" + asset.asset_line} className="d-inline-block">
              <img className="d-inline-block mr-2" alt="" src={asset.img_url} width="50" />
              {asset.name}
            </Link>
          </div>
          <div className="col-2">
            <p className="mt-3">
              Click "+" to find...  {/*Owner: <br /> {asset.current_lander}*/}
            </p>
          </div>

          <div className="col-md-3">
            <p className="pt-2 price-info" hidden={!asset.on_sale}>
              Current Asset Price <br />
              <ShowValue withoutBreak={false} btc={asset.price} />
            </p>
            <p className="pt-3 price-info" hidden={asset.on_sale}>
              Winvites on sale!
            </p>
          </div>

          <div className="col-md-2">
            <div hidden={asset.owner_address === this.state.lander_btc_address}>
              <Link className="btn btn-outline-success float-right mt-2" hidden={!asset.on_sale} to={"/assets/?assetline=" + asset.asset_line + "&buy=true"}>
                Buy now
              </Link>

            </div>

            <button
              className="btn btn-outline-primary float-right"
              hidden={!this.state.lander_btc_address || !asset.owner_address || asset.owner_address !== this.state.lander_btc_address}
              onClick={this.shareFB}
            >
              <i className="fab fa-facebook-f" />
              Share
            </button>
          </div>
        </div>

        <Collapse style={{ paddingLeft: this.assetSale.padding }} isOpen={this.state.collapseGroup[asset.asset_line]}>
          {this.hasChild(asset)}
        </Collapse>
      </section>
    );
  }

  hasChild(asset) {
    if (asset.child) {
      return asset.child.map(subasset => this.renderLine(subasset));
    }
  }

  render() {
  	
	  const { t } = this.props;
	  
    return (
      <div className="homepage">
	      
        <Carousel handleScrollToElement={this.handleScrollToElement} />
	      
	      <section>
		      <div className="container">
			      <div className="row justify-content-center">
				      <div className="col-md-12">
					      <div className="row justify-content-center">
						      <div className="col-lg-8 col-md-8 col-sm-12">
			           
						        <HowToBuy/>
							      
						      </div>
						      
					      </div>
				      </div>
			      </div>
		      </div>
	      </section>
	      
        <section className="home-section" ref="assets">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="row justify-content-center">

                  <div className="col-lg-5 col-md-5 col-sm-12">
                    <h3 className="section-title">
	                    {t('homepage.explore')} {/*Explore Experiências*/}
                    </h3>
                    <p className="section-subtitle">
	                    {t('homepage.browse')} {/*Navegue pelas Experiências*/}
                    </p>
                  </div>

                    {/*<div className="col-lg-7 col-md-7 col-sm-12">
                    <input className="input-search" type="text" placeholder="Search Experiences..."
                           onInput={this.handleInput} onChange={this.handleChange}
                           value={this.state.valueSearch} />
                  </div>*/}
                </div>

                <div className="row justify-content-center">
                  <div className="panel">
                    <div hidden={this.state.loading}>
                      <img className="d-block m-auto loading-img pb-1" width="50"
                           src="/public/assets/images/drumsloading.png" alt="loading icon" />

                      <p className="text-center text-primary">
                        Loading Experiências...
                      </p>
                    </div>

                    {this.state.assets.map((asset, index) => this.renderLine(asset))}

                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>{" "}

        <hr />

        <main className="main-content" ref="main">
          <section className="home-section">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-md-12">
                  <h3 className="section-title">{t('homepage.howitworks.title')}</h3>
                  <p className="section-subtitle">
	                  {t('homepage.howitworks.simplerules')}
                  </p>
                  <div className="panel">
	                  
	                  <p>
		                  {t('homepage.howitworks.ways')}
		                  {/*As experiências (winvites) são vendidas através de um sistema de leilão, que funciona da seguinte maneira:*/}
										</p>
	                  
	                  
                    <p>
	                    {t('homepage.howitworks.way1')}
	                    {/*1 - Você coloca crédito para dar o seu lance dentro de um leilão que esteja em aberto (cronômetro verde). Para colocar o crédito utilize o botão "Deposito" na sua Wallet.*/}
                    </p>

                    <br /><br />
	                  <p>
		                  {t('homepage.howitworks.way2')}
		                  {/*2 - Cada lance será dividido entre o Artista (Banda/Influencer), serviços (Agente), a Plataforma e os participantes do leilão.*/}
										</p>
                    
                    <br /><br />
	                  <p>
		                  {t('homepage.howitworks.way3')}
		                  {/*3 - Qualquer outro usuário pode dar outro lance em cima do seu. Nesse caso, você receberá de volta 100% do que pagou mais 20% (vinte por cento) sobre a diferença da nova oferta. Os valores estarão disponíveis na sua conta Winvite para uso na plataforma imediatamente caso você queira dar um novo lance. Fique tranquilo! Ao término do leilão, caso seu lance não seja vencedor, você poderá solicitar o estorno integral do lançamento feito no seu cartão e o cancelamento dos seus créditos* ou um TED para saque do valor na sua conta bancária** */}
	                  </p>
                    
                    <br /><br />
	                  
	                  <p>
		                  {t('homepage.howitworks.way4')}
		                  {/*4 - O lance vencedor no final do leilão (cronômetro vermelho) será o proprietário do Winvite e terá direito à usufruir da experiência única /colecionáveis conforme os termos e condições da oferta. O vencedor receberá um email com todas as informações.*/}
	                  </p>
	                  <br /><br />
	                  
	                  <p>
		                  {t('homepage.howitworks.way5')}
		                  {/* * Para solicitar o estorno integral , basta enviar de seu email cadastrado na plataforma uma mensagem para estorno@winvite.io colocando no título do email o leilão de que participou com a mensagem  "favor proceder o estorno integral e o cancelamento dos meus créditos" que iremos proceder o imediato cancelamento e o envio do comprovante. A devolução é realizada automaticamente pela empresa de pagamentos, e ocorre diretamente na fatura do seu cartão de maneira segura no mesmo mês ou no mês seguinte dependendo da data de fechamento da fatura.*/}
	                  </p> <br />
	                  
	                  <p>
		                  {t('homepage.howitworks.way6')}
		                  {/* **O pedido de saque via TED estará disponível 30 dias após o encerramento do leilão. Botão sacar ou envie email para saque@winvite.io. */}
	                  </p> <br />
                   
	                  <p>
		                  {t('homepage.howitworks.way7')}
		                  {/*Lembre-se: Você está aqui para viver experiências unicas*/}
                      <br /><br />
	                  </p>
                    
                    <p className="disclaimer-text">
                      <span className="disclaimer-title">{t('homepage.howitworks.disclaimer')} </span> <b>{t('common.winviteio')}</b>
	                    {t('homepage.howitworks.disclaimertext')}
                     
                    </p>
                    
                    
	                  
	                  <p>www.winvite.io - Todos os direitos reservados.</p>
	                  <p>NFT Tecnologia Ltda. CNPJ: 34.718.588/0001-35 - rc@winvite.io</p>
	                  
	                  <TermsConditions />
                   
                    
                  </div> {/* How it works text */}
                </div>
                
                

                  {/*
                <div className="col-md-12">
                  <img className="arrow-down mt-5" src="assets/images/down.gif"
                       onClick={e => this.handleScrollToElement(e, "main")} />
                </div> */} {/* Arrow */}


              </div>
            </div>
          </section>{" "}
          <hr />
        </main> {/* How it Works */}
          {/*<SubmitModal isOpen={this.state.modal} toggle={this.toggleModal} />*/}
	      
      </div>
    );
  }
}

export default withTranslation()(HomePage);



// WEBPACK FOOTER //
// ./src/containers/HomePage/index.js